export const enableBodyScrolling = (currentScrollTop: number) => {
  document.body.setAttribute('style', '');
  document.body.scrollTop = currentScrollTop;
};

export const disableBodyScrolling = () => {
  const currentScrollTop = document.body.scrollTop;
  document.body.setAttribute('style', 'overflow: hidden;');
  return currentScrollTop;
};
